var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-layout',{attrs:{"view":"lHh Lpr lFf"}},[_c('q-header',{attrs:{"elevated":""}},[_c('q-toolbar',[_c('q-toolbar-title',[_vm._v("Different Touch")])],1)],1),_c('q-page-container',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }